var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-hide-email-opt-in.j2"] = require( "loyalty-hide-email-opt-in.j2" );
dependencies["loyalty-create-email-opt-in.j2"] = require( "loyalty-create-email-opt-in.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-email-opt-in.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loyaltyConfig")),"showEmailSignUpAtAccountCreate")) {
output += "\n\n    <div class=\"o-row\">\n        <div class=\"g-loyalty-form__field-email-opt-in\">\n            <div class=\"c-form__field\">\n                <ul class=\"c-form-adjacent\">\n                        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userLocation")),"isUS") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"contextPath") == "/") {
output += "\n                            ";
env.getTemplate("loyalty-hide-email-opt-in.j2", false, "loyalty/templates/loyalty-email-opt-in.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n                        ";
})});
}
else {
output += "\n                            ";
env.getTemplate("loyalty-create-email-opt-in.j2", false, "loyalty/templates/loyalty-email-opt-in.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n                        ";
})});
}
output += "\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    <input\n        type=\"hidden\"\n        id=\"loyalty-email-subscription-source\"\n        name=\"emailSubscriptionSource\"\n        value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loyaltyConfig")),"emailSubscriptionSource"), env.opts.autoescape);
output += "\" />\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-email-opt-in.j2"] , dependencies)